function pickStatusCode(source: any): number | null {
  const candidates = [
    source?.statusCode,
    source?.status,
    source?.error?.statusCode,
    source?.error?.status
  ];
  const status = candidates.find((value) => Number.isFinite(Number(value)));
  if (!status) return null;
  return Number(status);
}

function pickMessage(source: any): string | null {
  if (!source) return null;

  if (typeof source === 'string') {
    const raw = source.trim();
    if (raw.startsWith('{') || raw.startsWith('[')) {
      try {
        const parsed = JSON.parse(raw);
        const parsedMessage = pickMessage(parsed);
        if (parsedMessage) return parsedMessage;
      } catch {
        // ignore invalid json string message and fallback to raw text
      }
    }

    return raw || null;
  }

  if (Array.isArray(source)) {
    const joined = source
      .map((item) => pickMessage(item))
      .filter(Boolean)
      .join('; ');
    return joined || null;
  }

  if (typeof source.message === 'string' && source.message.trim()) {
    return source.message;
  }

  if (Array.isArray(source.message) && source.message.length) {
    const joined = source.message
      .map((item: any) => pickMessage(item))
      .filter(Boolean)
      .join('; ');
    if (joined) return joined;
  }

  if (typeof source.error === 'string' && source.error.trim()) {
    return source.error;
  }

  if (Array.isArray(source.errors) && source.errors.length) {
    const joined = source.errors
      .map((item: any) => pickMessage(item))
      .filter(Boolean)
      .join('; ');
    if (joined) return joined;
  }

  return null;
}

export function extractApiErrorMessage(err: any, fallback: string): string {
  const directMessage = pickMessage(err);
  if (directMessage) return directMessage;

  const payloadMessage = pickMessage(err?.error);
  if (payloadMessage) return payloadMessage;

  const nestedPayloadMessage = pickMessage(err?.error?.error);
  if (nestedPayloadMessage) return nestedPayloadMessage;

  const statusCode = pickStatusCode(err);
  if (statusCode) return `${fallback} (код ${statusCode})`;

  return fallback;
}
